import type { OssHost } from './host';
import { createOssRoutes } from './route';
import { serviceScopes } from './service';

/**
 * The module for the app to mount: its services-hub routes, catalog scopes and the loader of the storage
 * landing gate (plain data and functions; the console stays a lazy chunk behind `route.ts`). The
 * host is a lazy factory, not a value: the app file that builds it imports hooks and APIs the entry
 * chunk does not need, so it is fetched when the route (or the landing) loads, and registered before
 * any code of the console runs. Taking it is the only way to get the routes, so the app cannot mount
 * the module and forget what it reads.
 */
export function createOssModule(loadHost: () => Promise<OssHost>) {
  const routes = createOssRoutes(loadHost);
  return { servicesRoutes: routes.servicesRoutes, loadStorageLanding: routes.loadStorageLanding, serviceScopes };
}

export type { OssHost } from './host';
